import { get } from 'lodash';
import { createSelector } from 'reselect';

import { cacheSelector } from 'selectors';

export const channelsSelector = createSelector(cacheSelector, (cache) => get(cache, 'channels'));
